var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-grid m-grid--hor m-grid--root m-page" },
    [
      _c("s-navbar", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loggedIn,
            expression: "loggedIn"
          }
        ]
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loggedIn,
              expression: "loggedIn"
            }
          ],
          staticClass:
            "m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body"
        },
        [
          _c("s-sidebar"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "m-grid__item m-grid__item--fluid m-wrapper" },
            [
              _vm.loggedIn && _vm.out_of_version
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "m-alert m-alert--icon alert alert-warning alert-update",
                        attrs: { role: "alert" }
                      },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-alert__text" }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")("update_title")
                                )
                              )
                            )
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")("update_message")
                                )
                              ) +
                              " \t\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-alert__actions" }, [
                          !_vm.validPermission("update", "update")
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn btn-info m-btn m-btn--icon",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.redirectConfiguration.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("span", [
                                    _c("i", {
                                      staticClass: "fa flaticon-paper-plane"
                                    }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("capitalize")(
                                            _vm._f("translate")("update")
                                          )
                                        )
                                      )
                                    ])
                                  ])
                                ]
                              )
                            : _vm._e()
                        ])
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.loggedIn ? _c("router-view") : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("s-footer", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loggedIn,
            expression: "loggedIn"
          }
        ]
      }),
      _vm._v(" "),
      !_vm.loggedIn ? _c("s-login") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-alert__icon" }, [
      _c("i", { staticClass: "la la-warning" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e82cbf2e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e82cbf2e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/App.vue
// module id = 953
// module chunks = 0 54